// Dwinov brand mark: navy rounded square with 3 ascending saffron→gold bars
// and a small circular "spark" accent breaking the top-right corner.
const DwinovMark = ({ size = 40 }) => {
  const scale = size / 40;
  const spark = 5 * scale;
  return (
    <svg
      width={size} height={size} viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`dwinovBar-${size}`} x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#E85D04" />
          <stop offset="100%" stopColor="#FAA307" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="36" height="36" rx="10" fill="#0D1B2A" />
      <rect x="7"    y="21" width="5" height="9"  rx="1.5" fill={`url(#dwinovBar-${size})`} />
      <rect x="15.5" y="15" width="5" height="15" rx="1.5" fill={`url(#dwinovBar-${size})`} />
      <rect x="24"   y="9"  width="5" height="21" rx="1.5" fill={`url(#dwinovBar-${size})`} />
      <circle cx="34" cy="6" r={spark} fill="#FAA307" stroke="#FFFBF5" strokeWidth="1.5" />
    </svg>
  );
};

export const DwinovLogo = ({ size = 40, showLabs = true }) => (
  <div className="flex items-center">
    <DwinovMark size={size} />
    <div className="ml-2.5 flex flex-col leading-none">
      <span className="font-display text-[22px] font-bold text-navy-800 tracking-tight">Dwinov</span>
      {showLabs && (
        <span className="mt-0.5 text-[9px] font-semibold text-saffron-600 tracking-[0.28em]">LABS</span>
      )}
    </div>
  </div>
);

export default DwinovMark;
